<div [ngClass]="klass">
    <ng-content></ng-content>
</div>
